import React, { createContext, useContext, useState } from 'react';
import { postData} from '../../services/Api';

const CaixaMovContext = createContext();

export const useCaixaMov = () => useContext(CaixaMovContext);

export const CaixaMovProvider = ({ children }) => {
    const [caixasMov, setCaixasMov] = useState([]);

    const abrirCaixa = async (caixaMov) => {
        try {
            const result = await postData('/CaixaMov/AbrirCaixa', caixaMov);
            setCaixasMov([...caixasMov, result]);
         
        } catch (error) {
            throw error;
            //console.error('Erro ao abrir o caixa:', error);
            //showMessage('Erro ao abrir o caixa!', 'danger');
        }
    };

    const lancManual = async (caixaMov) => {
        try {
            const result = await postData('/CaixaMov/LancManual', caixaMov);
            setCaixasMov([...caixasMov, result]);            
        } catch (error) {
            throw error;
            //console.error('Erro ao efetuar a movimentação do caixa:', error);
            //showMessage('Erro ao efetuar a movimentação do caixa!', 'danger');
        }
    };

    const fecharCaixa = async (caixaMov) => {
        try {
            const result = await postData('/CaixaMov/FecharCaixa', caixaMov);
            setCaixasMov([...caixasMov, result]);
        } catch (error) {
            throw error;
        }
    };

    return (
        <CaixaMovContext.Provider value={{
            caixasMov,
            abrirCaixa,
            fecharCaixa,  
            lancManual,          
        }}>
            {children}
        </CaixaMovContext.Provider>
    );
};